import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { GridPagination } from '@mui/x-data-grid';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function TableTools({
  rows,
  loading,
  onRowClick,
  page,
  pageSize,
  rowCount,
  setPage,
  setPageSize,
  columns,
  columnVisibilityModel, 
  setColumnVisibilityModel
}) {
  const { t } = useTranslation();
  const rowsWithId = rows.map((r) => ({ ...r, id: r.cipId }));
  
  function LeftPagination(props) {
    return (
      <Box display="flex" justifyContent="flex-start" px={2}>
        <GridPagination {...props} />
      </Box>
    );
  }

  return (
            <Box >
                <Card>
              <CardHeader />
          <CardContent>
            <DataGrid
              rows={rowsWithId}
              columns={columns}
              rowCount={rowCount}
              loading={loading}
              paginationMode="server"
              paginationModel={{ page, pageSize }}
              onPaginationModelChange={({ page, pageSize }) => {
                setPage(page);
                setPageSize(pageSize);
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              disableSelectionOnClick
              getRowId={(row) => row.cipId}
              onRowClick={(params) => onRowClick?.(params.row)}
              sx={{
                border: '1px solid #ccc',
                '& .MuiDataGrid-footerContainer': {
                  justifyContent: 'flex-start',
                },
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: '#607d8b',
                  color: '#fff',
                  fontWeight: 'bold',
                },
                '& .MuiDataGrid-row': {
                  backgroundColor: '#fff', 
                },
                '& .MuiDataGrid-row:nth-of-type(even)': {
                  backgroundColor: '#f5f5f5', 
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#e3f2fd',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid #eee',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
              density="compact"
              style={{ height: 600 }}
              slots={{ pagination: LeftPagination }}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={()=>setColumnVisibilityModel()}
            />
            </CardContent> 
          </Card>
      </Box>
  );
}
